import { useFormik } from 'formik';
import { validatePassword } from 'shared/utils/room-shared';
import { object, ref, string } from 'yup';

type Props = {
  onSubmit: ({ password, password_confirmation }: any) => void;
};
export const usePasswordForm = ({ onSubmit }: Props) => {
  const validationSchema = object({
    password: string()
      .required('Password is required')
      .min(8, 'Password must be atleast 8 characters')
      .test('passwordValidate', 'Invalid Password', (value) => {
        if (value) {
          const validatePasswordResult = validatePassword(value);
          return validatePasswordResult.IsValid;
        }
        return false;
      }),
    password_confirmation: string()
      .required('Password confirmation is required')
      .oneOf([ref('password')], 'Your passwords do not match.'),
  });

  const initialValues = {
    password: '',
    password_confirmation: '',
  };

  const form = useFormik({
    validationSchema,
    initialValues,
    onSubmit: (values, helpers) => {
      onSubmit(values);
    },
  });

  return {
    form,
  };
};
